export default __webpack_public_path__ + "static/media/Blog1_1.e8c1c87f.jpg";